import { Box } from "@mui/material"

export const MainPage = () => {
  return (
    <Box sx={{ width: 'auto', backgroundColor: '#EEE' }} ></Box>
  )
}